export default {
  items: [
    // {
    //   name: 'Export List',
    //   url: '/export_list',
    //   icon: 'download',
    // },
    // {
    //   name: 'Trending',
    //   url: '/trending',
    //   icon: 'fa fa-line-chart',
    // },
    {
      name: 'Home',
      url: '/',
      icon: 'home',
    },
    {
      name: 'Export',
      url: '/welcome',
      icon: 'fa fa-download',
    },
    //   {
    //   name: 'Co-Op',
    //   url: '/co-op',
    //   icon: 'addyourcompany',
    // },
    
    {
      name: 'News',
      url: '/blog',
      icon: 'news',
    },
    {
      name: 'Company Data API',
      url: '/company_data_api',
      icon: 'company_api',
    },
    {
      name: 'About Us',
      url: '/aboutus',
      icon: 'about',
    },
    // {
    //   name: 'Add Your Company',
    //   url: '/add-your-company',
    //   icon: 'addyourcompany',
    // },
    // {
    //   name: 'Search',
    //   url: '/search',
    //   icon: 'search',
    // },
    // {
    //   name: 'Recently Added Companies',
    //   url: '/recently_added',
    //   icon: 'recently_added',
    // },
    // {
    //   name: 'Algo',
    //   url: '/algo',
    //   icon: 'algo',
    // },
    // {
    //   name: 'Join',
    //   url: '/join',
    //   icon: 'join',
    // },
    // {
    //   name: 'API',
    //   url: '/company_api',
    //   icon: 'update',
    // },
    // {
    //   name: 'Top Pages',
    //   url: '/top_competitors',
    //   icon: 'update',
    // },
    // {
    //   name: 'Media',
    //   url: '/media',
    //   icon: 'media',
    // },
    // {
    //   name: 'Sign In',
    //   url: '/login',
    //   icon: 'icon-login',
    // },
    {
      name: 'Contact Us',
      url: '/contact',
      icon: 'contact',
    },
    // {
    //   name: 'My Company',
    //   url: '/company/',
    //   icon: 'news',
    // },
    // {
    //   name: 'Update Company',
    //   url: '/edit_company/',
    //   icon: 'news',
    // },
    // {
    //   name: 'Register Company',
    //   url: '/register-company/',
    //   icon: 'news',
    // },
    // {
    //   name: 'Logout',
    //   url: '/logout',
    //   icon: 'icon-logout',
    // },
    // {
    //   name: 'Terms&Conditions',
    //   url: '/terms',
    //   // icon: 'update',
    // },
    // {
    //   name: 'Privacy',
    //   url: '/privacy',
    //   // icon: 'update',
    // },
    // {
    //   name: 'Contact Us',
    //   url: '/contact',
    //   // icon: 'update',
    // },
    // {
    //   name: 'Reports',
    //   url: '/reports_awards',
    //   icon: 'home',
    // },
  ]
};
//fa fa-user-plus


// WEBPACK FOOTER //
// ./client/src/components/Sidebar/_nav.js